/**
 * Extract the first human-readable error message from TanStack Form's error array.
 *
 * TanStack Form errors can be strings (from inline validators) or
 * `StandardSchemaV1Issue` objects (from Valibot/Zod schemas). This utility
 * normalizes them to a single string for display in UAD field components.
 */
export function getFieldErrorMessage(errors: unknown[]): string | undefined {
  if (errors.length === 0) {
    return undefined;
  }

  const firstError = errors[0];

  if (typeof firstError === 'string') {
    return firstError;
  }

  if (
    typeof firstError === 'object' &&
    firstError !== null &&
    'message' in firstError &&
    typeof firstError.message === 'string'
  ) {
    return firstError.message;
  }

  return String(firstError);
}
